// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_nv-0";
export var buttonContainer = "_nv-3";
export var cancelButton = "_nv-4";
export var headerSection = "_nv-6";
export var headerTitle = "_nv-9";
export var messageSideLeft = "_nv-1";
export var messageSideRight = "_nv-2";
export var orderNumberContainer = "_nv-7";
export var orderNumberLabel = "_nv-8";
export var submitButton = "_nv-5";